export enum CustomValueTooltipElement {
  RequiredExperience,
  ProfileColumn,
  Tags,
  VerifiedIcons,
  State,
  Custom
}
